import request from '@/util/request'


export const navList = (data) => request.post('/api/v1/index/index', data);  //导航接口

export const submitMsg = (data) => request.post('/api/v1/message/index', data);  //留言

export const newsList = (data) => request.post('/api/v1/article/index', data);  //获取新闻

export const newsInfo = (data) => request.post('/api/v1/article/detail', data);  //获取新闻详情

export const searchList = (data) => request.post('/api/v1/search/index', data);  //搜索

export const productSelectList = (data) => request.post('/api/v1/product/sel_list', data);  //产品筛选列表

export const productList = (data) => request.post('/api/v1/product/index', data);  //产品列表

export const productInfo = (data) => request.post('/api/v1/product/detail', data);  //产品详情

export const productCount = (data) => request.post('/api/v1/product/tongji', data);  //产品详情访问统计

export const bannerList = (data) => request.post('/api/v1/ad/index', data);  //轮播图列表